import clsx from 'clsx'
import {Fragment} from 'react'
import {Row} from 'react-table'
import { ApplicationAssessment, ApplicationTest } from '../../modules/core/applications'

type AllowedData = ApplicationTest | ApplicationAssessment;

type Props<T extends AllowedData> = {
  row: Row<T>;
};

export const TableReportRow = <T extends AllowedData>({ row }: Props<T>) => {
  const { key: rowKey, ...restRowProps } = row.getRowProps();

  return (
  <Fragment key={rowKey}>
    <tr {...restRowProps}>
    {row.cells.map((cell, cidx) => {
      const { key: cellKey, ...restCellProps } = cell.getCellProps();
      return (
        <td
          key={cellKey} 
          {...restCellProps}
          rowSpan={cidx === 0 ? 2 : 1}
          className={clsx('fs-7', {'align-top pt-5': cell.column.id === 'testReferenceNumber'})}
          style={{whiteSpace: 'pre-line'}}
        >                    
          {cell.render('Cell')}
        </td>
      )
    })}
    </tr>
    <tr>
      <td colSpan={2} className="p-0 align-top">
        <div className="d-flex flex-row items-align-start gap-4 p-4">
          <div role="columnheader" 
            className={clsx("fs-7 fw-bolder text-muted text-uppercase min-w-90px",
              {"position-relative changed" : row.original.testLocationChanged}
            )}            
          >
              LOCATION :
          </div>
          { row.original.testLocation &&
          <div style={{whiteSpace: 'pre-line'}} className="fs-7 lh-sm">
            {row.original.testLocation}
          </div>
          }
        </div>
      </td>
      <td colSpan={3} className="p-0 align-top">
        <div className="d-flex flex-row items-align-start gap-4 p-4">
          <div role="columnheader" 
            className={clsx("fs-7 fw-bolder text-muted text-uppercase min-w-70px",
              {"position-relative changed" : row.original.testLocationChanged}
            )}
            title={row.original.testLocationChanged ? 'changed' : ''}
          >
            RESULT :
          </div>
          { row.original.testResult &&
          <div style={{whiteSpace: 'pre-line'}} className="fs-7 lh-sm">
            {row.original.testResult}
          </div>
          }
        </div>
      </td>
    </tr>
  </Fragment>
  )
}
